import React, { Component } from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'

import { Get } from 'utils/axios'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      academicAdvisorStudents: {
        data: [],
        meta: {
          page: 1,
          page_count: 0,
          per_page: 1,
          total_count: 0,
        }
      }
    }

    load = param => this.setState({ loading: param })
    requestError = error => toast.error( error )
    requestSuccess = success => toast.success( success )

    getAcademicAdvisorStudents = () => Get(
      `/academic_advisor_students?query=${ btoa( `{"academic_advisor_id":${ this.props.data.ProfileReducer.profile.user.id }}` ) }`,
      this.getAcademicAdvisorStudentsSuccess,
      this.getAcademicAdvisorStudentsError,
      this.load,
      this.props.data.ProfileReducer.current_role_id
    )
    getAcademicAdvisorStudentsSuccess = payload => this.setState({ academicAdvisorStudents: payload })
    getAcademicAdvisorStudentsError = error => this.requestError( error )

    render = () => {
      return (
        <WrappedComponent
          { ...this.props } 
          academicAdvisorStudents={ this.state.academicAdvisorStudents }
          onLoadAcademicAdvisorStudents={ this.state.loading }
          getAcademicAdvisorStudents={ this.getAcademicAdvisorStudents } />
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return connect( mapStateToProps )( WithHOC )
}

export default HOC